import { create } from "zustand";

/**
 * State of the organisation event stream (`/sse/org-notifs-<orgId>`), kept
 * by the headless SSE component and shown as the "online" dot in the side
 * menu. `online` means the browser has an open EventSource to api-gateway;
 * it says nothing about the API itself, but the stream shares the gateway,
 * so a dead stream usually means a dead gateway too.
 */
export type SseStatus = "connecting" | "online" | "offline";

interface SseStore {
	status: SseStatus;
	/** When the current status was entered. */
	since: number;
	setStatus(status: SseStatus): void;
}

export const useSseStore = create<SseStore>()((set) => ({
	status: "connecting",
	since: Date.now(),

	setStatus(status) {
		set((state) => (state.status === status ? state : { status, since: Date.now() }));
	},
}));
